/**
 * Team / Chefs Content
 *
 * Chef profiles, social links, and related content.
 */

const teamContent = {
  section: {
    subtitle: 'experienced team',
    title: 'Meet Our Chef',
  },

  chefs: [
    {
      id: 1,
      name: 'Willium Joe',
      designation: 'Master chef',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      image: 'team-1.jpg',
      socials: [
        { platform: 'Facebook', icon: 'fab fa-facebook-f', url: '#' },
        { platform: 'Twitter', icon: 'fab fa-twitter', url: '#' },
        { platform: 'Dribbble', icon: 'fab fa-dribbble', url: '#' },
        { platform: 'LinkedIn', icon: 'fab fa-linkedin-in', url: '#' },
      ],
    },
    {
      id: 2,
      name: 'Steave Den',
      designation: 'Master chef',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      image: 'team-2.jpg',
      socials: [
        { platform: 'Facebook', icon: 'fab fa-facebook-f', url: '#' },
        { platform: 'Twitter', icon: 'fab fa-twitter', url: '#' },
        { platform: 'Dribbble', icon: 'fab fa-dribbble', url: '#' },
        { platform: 'LinkedIn', icon: 'fab fa-linkedin-in', url: '#' },
      ],
    },
    {
      id: 3,
      name: 'Lily Sopy',
      designation: 'Master chef',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      image: 'team-3.jpg',
      socials: [
        { platform: 'Facebook', icon: 'fab fa-facebook-f', url: '#' },
        { platform: 'Twitter', icon: 'fab fa-twitter', url: '#' },
        { platform: 'Dribbble', icon: 'fab fa-dribbble', url: '#' },
        { platform: 'LinkedIn', icon: 'fab fa-linkedin-in', url: '#' },
      ],
    },
  ],

  chefPage: {
    breadcrumb: {
      subtitle: 'Meet Our Chef',
      title: 'OUR TEAM',
    },
    chefSection: {
      subtitle: '35 year of experience',
      title: 'Award Winning Chef',
      text: 'Lorem Ipsum is simply dummy text of the printingand typesetting industry lorem Ipsum has been the industrys standard dummy text ever since the when an unknown printer took a galley of type.',
      author: 'Henry - EXCUTIVE CHEF',
    },
    quoteSection: {
      quote: 'A modern restaurant with a menu that will make your mouth water.',
      author: 'Henry - Master chef',
    },
  },
};

export default teamContent;
